

// 渲染问候弹窗，只展示一次（基于 sessionStorage 标记）
export const renderGreetingPopup = ({
    content,
    agentLabel = '<div class="label">AI</div>',
    popupShownKey = 'crgl-greeting-popup-shown',
    modalSelector = '.crgl-feedback-modal',
    triggerButtonId = 'feedback-ai-btn'
} = {}) => {
    // 已展示过则跳过
    if (sessionStorage.getItem(popupShownKey) === 'true') return false;

    const modal = document.querySelector(modalSelector);
    const isModalOpen = modal &&
        modal.offsetParent !== null &&
        window.getComputedStyle(modal).display !== 'none' &&
        window.getComputedStyle(modal).visibility !== 'hidden';
    // 如果模态框已打开，不显示 popup
    if (isModalOpen) return false;

    const feedbackBtn = document.getElementById(triggerButtonId);
    // 如果触发按钮不存在，不显示 popup
    if (!feedbackBtn) return false;

    // 移除已存在的 popup（如果存在）
    const existingPopup = document.getElementById('crgl-greeting-popup');
    if (existingPopup) existingPopup.remove();

    // 创建 popup 元素
    const popup = document.createElement('div');
    popup.id = 'crgl-greeting-popup';
    popup.className = 'crgl-greeting-popup';
    popup.innerHTML = `
        <div class="answer-section">
            <div class="label">${agentLabel}</div>
            <div class="answer-text">${content}</div>
        </div>
        <div class="crgl-greeting-popup-close" />
    `;

    // 定位：按钮上方，右侧固定 30px
    const btnRect = feedbackBtn.getBoundingClientRect();
    popup.style.right = `30px`;
    popup.style.bottom = `${window.innerHeight - btnRect.top + 16}px`;

    const markShown = () => sessionStorage.setItem(popupShownKey, 'true');

    // 关闭按钮
    const closeBtn = popup.querySelector('.crgl-greeting-popup-close');
    closeBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        popup.remove();
        markShown();
    });

    // 点击 popup 打开 modal
    const openModal = () => {
        const faqModal = window.CrglFAQInstance;
        if (faqModal) {
            let modalContainer = document.getElementById('crgl-modal-container');
            if (!modalContainer) {
                modalContainer = document.createElement('div');
                modalContainer.id = 'crgl-modal-container';
                document.body.appendChild(modalContainer);
            }
            faqModal.render(modalContainer);
            popup.remove();
            markShown();
        }
    };
    
    // 点击 popup 内容区域打开 modal（只绑定到内容区域，不影响关闭按钮）
    const answerSection = popup.querySelector('.answer-section');
    answerSection?.addEventListener('click', openModal);

    // 点击触发按钮关闭
    const closeOnBtnClick = () => {
        popup.remove();
        markShown();
        feedbackBtn.removeEventListener('click', closeOnBtnClick);
    };
    feedbackBtn.addEventListener('click', closeOnBtnClick, { once: true });

    document.body.appendChild(popup);
    markShown();

    // 监听模态框出现，出现则移除
    const checkModalAndClose = () => {
        const currentModal = document.querySelector(modalSelector);
        if (currentModal &&
            currentModal.offsetParent !== null &&
            window.getComputedStyle(currentModal).display !== 'none') {
            popup.remove();
            markShown();
            observer.disconnect();
        }
    };

    const observer = new MutationObserver(checkModalAndClose);
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
    });

    // 如果 popup 被移除，停止观察
    const popupObserver = new MutationObserver(() => {
        if (!document.body.contains(popup)) {
            observer.disconnect();
            popupObserver.disconnect();
        }
    });
    popupObserver.observe(document.body, { childList: true });

    return true;
};

